<template>
    <div>
        <!-- User Interface controls -->


        <!-- Main table element -->
            <b-table show-empty empty-text="Please wait while the pcrs to load." striped responsive stacked="md" 
                 :items="items" 
                 :fields="fields" 
                  :filter="filter" 
                  :sort-by.sync="sortBy"
				 :sort-desc.sync="sortDesc"
                 @filtered="onFiltered">
<template v-slot:cell(date)="row">
				{{ moment(row.item.date).format('MMM DD YYYY') }}
			</template>
<template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                    <b-button @click="signOff(row.item.id)" class="btn btn-primary">
                        <span class="icon icon-check">
                            Sign-off</span>
                    </b-button>
                </b-button-group>
            </template>
</b-table>


</div>
</template>

<script>
	const items = [];
	var moment = require('moment');
	export default {
		props: ['pcrs', 'url'],
		data() {
			return {
				items: this.pcrs,
				moment: moment,
				fields: [
                    {
						key: "user.name",
						label: "Student",
                    },
                    {
                        key: "course",
                        label: "Course"
                    },
					{
						key: "date",
						label: "Call Date",
					},
					{
						key: "actions",
						label: "Actions"
					}
				],
				filter: null,
				sortBy: "date",
				sortDesc: false,
			};
		},
		computed: {
			sortOptions() {
				// Create an options list from our fields
				return this.fields.filter(f => f.sortable).map(f => {
					return {
						text: f.label,
						value: f.key
					};
				});
			}
		},
		methods: {
			signOff(id) {
				window.location.href = this.url + id;
			},
		},
	};
</script>

<!-- table-complete-1.vue -->